import React from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckIcon from '@material-ui/icons/Done';
import ConditionalTooltip from '../../ConditionalTooltip';
import Editor, { TABLE_CELL_COMPONENT, FORM_FIELD_COMPONENT, NOT_APPLICABLE } from '../Editor';
import './BooleanEditor.scss';

const BooleanTableCell = ({ value }) => {
  if (!value) return <span />;
  return (
    <CheckIcon className="grb-boolean-tablecell-editor" />
  );
};

BooleanTableCell.propTypes = {
  value: PropTypes.bool,
};

BooleanTableCell.defaultProps = {
  value: undefined,
};

class BooleanComponent extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.bool,
    object: PropTypes.shape({}),
    editing: PropTypes.bool,
    label: PropTypes.string,
    description: PropTypes.string,
    // error: PropTypes.string,
    readOnly: PropTypes.bool,
    form: PropTypes.bool,
  }

  static defaultProps = {
    value: undefined,
    object: undefined,
    // error: null,
    readOnly: false,
    label: null,
    editing: false,
    description: undefined,
    form: false,
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(Object.assign({}, event, { target: { value: event.target.checked } }));
    }
  };

  render() {
    const {
      value,
      object,
      editing,
      // error,
      label,
      readOnly,
      form,
      description,
    } = this.props;
    if (form) {
      return (
        <ConditionalTooltip title={description}>
          <FormControlLabel
            control={(
              <Checkbox
                checked={Boolean(value)}
                onChange={!readOnly && editing ? this.handleChange : undefined}
                color={!readOnly && editing ? 'primary' : 'default'}
              />
            )}
            label={label}
            className="grb-boolean-form-editor"
          />
        </ConditionalTooltip>
      );
    }
    return (
      <Checkbox
        checked={object ? !!value : false}
        onChange={object && !readOnly && editing ? this.handleChange : undefined}
        color={readOnly || !editing ? 'default' : 'primary'}
        disableRipple
      />
    );
  }
}

export default class BooleanEditor extends Editor {
  constructor(name, options, components) {
    super(name || 'boolean', Object.assign({}, {
      [TABLE_CELL_COMPONENT]: [BooleanTableCell, BooleanTableCell],
      [FORM_FIELD_COMPONENT]: [BooleanComponent, BooleanComponent],
    }, components));
  }

  formatValue(value) {
    return value === undefined ? NOT_APPLICABLE : (value && 'true' || 'false');
  }
}

